export default __webpack_public_path__ + "images/long-right-arrow-red.png?7529834e445c02a8ff54602a9e8992ee";